// src/App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  // Oturum yükleme kontrolü ProtectedRoute içinde yapılıyor.
  return (
    <div className="App">
      <AppRoutes />
      <ToastContainer
        position="bottom-right" // Bildirimlerin konumu
        autoClose={4000} // Otomatik kapanma süresi (4 saniye)
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // "light", "dark", veya "colored"
      />
    </div>
  );
}

export default App;
